import { Button } from 'components/buttons/Button/Button';
import PDFCard from './PDFCard';
import './styles.scss';

const PDFBox = ({ title = '', data }) => {
    return (
        <div className="box pdf-box">
            {title && <h3>{title}</h3>}
            <div className="pdf-items">
                {data.map(el => (
                    <PDFCard key={el} title={el} />
                ))}
            </div>
            {data.length > 3 && <Button type="show-more">SHOW MORE</Button>}
        </div>
    );
};

export default PDFBox;
